function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var invalidProps = function invalidProps(_ref) {
  var invalid = _ref.invalid,
      errorId = _ref.errorId;
  return {
    'data-invalid': invalid,
    'aria-invalid': invalid,
    'aria-describedby': errorId
  };
};

export var textInputProps = function textInputProps(_ref2) {
  var invalid = _ref2.invalid,
      sharedTextInputProps = _ref2.sharedTextInputProps,
      errorId = _ref2.errorId;
  return _objectSpread({}, sharedTextInputProps, {}, invalid ? invalidProps({
    invalid: invalid,
    errorId: errorId
  }) : {});
};